import { set, toggle } from '@/utils/vuex'

export default {
  setRole: set('role'),
  setUser: set('user'),
  setInstitution: set('institution'),
  setInstitutions: set('institutions'),
  setSession: set('session'),
  setDrawer: set('drawer'),
  setLevels: set('levels'),
  setEvents: set('events'),
  toggleDrawer: toggle('drawer'),
}



// WEBPACK FOOTER //
// ./src/store/mutations.js